export default __webpack_public_path__ + "static/media/EXEMPLO 4.70e748e2.jpg";